import {
  deleteUserData,
  getUserData,
  getUserLogin,
  getUserOptions,
  getUserSetting,
  patchUserSendConfirmation,
  patchUserSetting,
  postPaiementSession,
  postUserData,
  postUserRegister,
} from '../../api/users.api'
import router from '@/router.ts'

const state = {
  isWebView: false,
  // Sticky: set when the app enters the portal with a device hint in the query
  // (?serial= / ?identifier=), like isWebView is set from ?webview=true.
  hasDeviceQuery: false,
  userSetting: null,
  userName: null,
  userRole: null,
  emailConfirmed: null,
  token: null,
}

const getters = {
  getUserSetting(state) {
    return state.userSetting
  },
  getEmailConfirmed(state) {
    return state.emailConfirmed
  },
  getToken(state) {
    if (!state.token) {
      state.token = localStorage.getItem('token')
    }
    return state.token
  },
  getUserName(state) {
    return state.userName
  },
  getUserRole(state) {
    return state.userRole
  },
  isWebView(state) {
    return state.isWebView
  },
  hasDeviceQuery(state) {
    return state.hasDeviceQuery
  },
}

const actions = {
  async userRegister({ commit }, user_data) {
    try {
      const response = await postUserRegister(user_data)
      return response
    } catch (error) {
      return error
    }
  },
  async fetchUserSetting({ commit }, user_data) {
    try {
      const response = await getUserSetting(user_data)
      commit('SET_USER_SETTING', response.data)
    } catch (error) {
      return error
    }
  },
  async updateUserProfile({ commit }, data) {
    try {
      const response = await patchUserSetting(data)
      return response
    } catch (error) {
      console.error('updateUserProfile', error)
      return error
    }
  },
  async sendEmailConfirmation({ commit }, data) {
    try {
      const response = await patchUserSendConfirmation(data)
      return response
    } catch (error) {
      console.error('sendEmailConfirmation', error)
      return error
    }
  },
  async fetchUser({ commit }, user_data) {
    try {
      const response = await postUserData(user_data)
      commit('SET_USERNAME', response.data.user)
      commit('SET_TOKEN', response.data.token)
      return true
    } catch {
      return false
    }
  },
  async deleteUserData({ commit }, user_data) {
    try {
      const response = await postUserData(user_data)
      if (response.status == 200) {
        deleteUserData()
      } else {
        console.warn('deleteUserData: invalid password')
      }
      return response
    } catch (error) {
      console.error('deleteUserData', error)
      return 'error'
    }
  },
  async fetchUserData({ commit }) {
    try {
      const response = await getUserData()
      commit('SET_USERNAME', response.data.username)
    } catch (error) {
      return error
    }
  },
  async login({ commit }) {
    try {
      const response = await getUserLogin()
      commit('SET_USERNAME', response.data.user)
      return response
    } catch (error) {
      console.error('login', error)
    }
  },
  async logout({ commit }) {
    commit('REMOVE_TOKEN')
    if (window.sessionStorage) {
      sessionStorage.clear()
    }
  },
  async paiementSession({ commit }, paiementSession_data) {
    try {
      const response = await postPaiementSession(paiementSession_data)
      Stripe(response.data.public_key).redirectToCheckout({
        sessionId: response.data.id,
      })
      return response
    } catch (error) {
      console.error('paiementSession', error)
      return error
    }
  },
  async fetchUserRole({ commit }) {
    try {
      const response = await getUserOptions()
      commit('SET_EMAIL_CONFIRMATION', response.data.email_confirmed)
      commit('SET_USERROLE', response.data.role)
    } catch (error) {
      console.error('fetchUserRole', error)
    }
  },
  async setToken({ commit }, data) {
    commit('SET_TOKEN', data)
  },
  async removeToken({ commit }) {
    commit('REMOVE_TOKEN')
  },
  async setIsWebView({ commit }, data) {
    commit('SET_ISWEBVIEW', data)
  },
  async setHasDeviceQuery({ commit }, data) {
    commit('SET_HAS_DEVICE_QUERY', data)
  },
}

const mutations = {
  SET_USER_SETTING(state, data) {
    state.userSetting = data
  },
  SET_USER_DATA(state, data) {
    state.userSetting.firstname = data.firstname
    state.userSetting.lastname = data.lastname
    state.userSetting.birthday = data.birthday
  },
  SET_ISWEBVIEW(state, data) {
    state.isWebView = data
  },
  SET_HAS_DEVICE_QUERY(state, data) {
    state.hasDeviceQuery = data
  },
  SET_TOKEN(state, data) {
    localStorage.setItem('token', data)
    state.token = data
  },
  REMOVE_TOKEN(state) {
    localStorage.removeItem('token')
    state.token = null
  },
  SET_USERNAME(state, data) {
    state.userName = data
  },
  SET_EMAIL_CONFIRMATION(state, emailConfirmed) {
    state.emailConfirmed = emailConfirmed
  },
  REMOVE_USERNAME(state, data) {
    state.userName = null
  },
  SET_USERROLE(state, data) {
    state.userRole = data
  },
  REMOVE_USERROLE(state, data) {
    state.userRole = null
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
